<ng-container *ngIf="onGetErrorMessage()?.length">
	<span class="c-validation-message__error">
		{{ onGetErrorMessage() }}
	</span>
</ng-container>
